import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HomeComponent } from '../home/home.component';
import { LoginComponent } from '../login/login.component';
import { ModelComponent } from '../model/model.component';
import { AuthGuard }  from '../auth.guard';
// import {UrlSerializer, UrlTree, DefaultUrlSerializer} from '@angular/router';

const routes: Routes = [
  {
    path: 'profile',
    //component: ProfileComponent,
    loadChildren: 'app/lazy/lazy.module#LazyModule',
  },
  {
    path: 'login-signup',
    loadChildren: 'app/login-signup/login-signup.module#LoginSignupModule',

  },
  { 
    path:'bike-model/:id/:months',
    loadChildren: 'app/bike-selection/bike-selection.module#BikeSelectionModule',

  },
  {
    path: 'model/:name/:id/:months',
    loadChildren: 'app/model-bike/model-bike.module#ModelBikeModule',

  },
  {
    path: 'referral',
    loadChildren: 'app/referral/referral.module#ReferralModule'
  },
  {
    // path: 'success/:id',
    path: 'payment/:id', 
    loadChildren: 'app/payment-success/payment-success.module#PaymentSuccessModule'

  },
  {
    path: '404', 
    loadChildren: 'app/page-not-found/page-not-found.module#PageNotFoundModule'
  },

  {
    path: 'extendpayment/:id',
    loadChildren: 'app/extend-booking-payment-success/extend-booking-payment-success.module#ExtendBookingPaymentSuccessModule'
  },
  {
    path: 'payment/:id/:status', 
    loadChildren: 'app/penalty-payment/penalty-payment.module#PenaltyPaymentModule'
  },
  {
    path: 'userAccount',
    loadChildren: 'app/userprofile/userprofile.module#UserprofileModule'
  },
   
  {
    path: 'documents',
    loadChildren: 'app/userdocuments/userdocuments.module#UserdocumentsModule'
  },
  {
    path: 'completed',
    loadChildren: 'app/completed-booking/completed-booking.module#CompletedBookingModule'
  },
  {
    path: 'ongoing',
    loadChildren: 'app/ongoing-booking/ongoing-booking.module#OngoingBookingModule'
  },
  {
    path: 'vehicleDocuments',
    loadChildren: 'app/vehicle-documents/vehicle-documents.module#VehicleDocumentsModule'
  },

  {
    path: 'details',
    loadChildren: 'app/userdetails/userdetails.module#UserdetailsModule'
    },
    {
      path: 'MyProfile',
      loadChildren: 'app/my-profile/my-profile.module#MyProfileModule'
    },
    {
      path: 'reset/:token',
      loadChildren: 'app/reset-password/reset-password.module#ResetPasswordModule'
    },
  {
    path: '',
    component: ModelComponent,
    data:{title:"Ontrack: Monthly bike rental in Bangalore | Bike rentals in Bangalore"}
  },
  {
    path: 'model',
    component: ModelComponent,
    data: {title: "Models"}
  },
  {path: '**', redirectTo: '/404'},
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule {
  
//   parse(url: any): UrlTree {
//     let dus = new DefaultUrlSerializer();
//     return dus.parse(url);
// }

// serialize(tree: UrlTree): any {
//     let dus = new DefaultUrlSerializer(),
//         path = dus.serialize(tree);
//     // use your regex to replace as per your requirement.
//     return path.replace(/%20/g,'_').replace(/%2F/g,'_');
    
// }
}



// WEBPACK FOOTER //
// C:/unnati/backup/latestWebCode29march/backup17-june-20/src/app/app-routing/app-routing.module.ts